import React from "react";
import { VERDICT_BADGE } from "./shared";

// Segnali compra / tieni / vendi (ibrido: regole + AI). Presentazionale.
export const SignalsPanel = ({ signals }) => {
  if (!signals || (signals.signals || []).length === 0) return null;
  return (
    <div className="mt-6" data-testid="invest-signals">
      <p className="caps-tag mb-2 flex items-center gap-1.5 text-white/45">
        <span aria-hidden style={{ color: "#34D399" }}>◉</span> Segnali · compra / tieni / vendi
      </p>
      <div className="space-y-2">
        {signals.signals.map((s, i) => (
          <div key={s.symbol} className="rounded-[10px] border border-white/[0.06] bg-[#0D0D14] p-3" data-testid={`signal-row-${i}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="mono text-[13px] text-white/90">
                {s.symbol} <span className="text-white/35">· {s.weight}%</span>
              </span>
              <span
                className="mono rounded-[5px] border px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.1em]"
                style={VERDICT_BADGE[s.tone] || VERDICT_BADGE.neutral}
                data-testid={`signal-verdict-${s.symbol}`}
              >
                {s.verdict_label}
              </span>
            </div>
            <p className="mt-1.5 text-[12px] font-light leading-snug text-white/55" data-testid={`signal-rationale-${s.symbol}`}>
              {s.rationale || s.reason_text}
            </p>
          </div>
        ))}
      </div>
      <p className="mono mt-3 text-[10px] leading-4 tracking-[0.03em] text-white/30" data-testid="signals-disclaimer">
        {signals.disclaimer}
      </p>
    </div>
  );
};
